import React, { useMemo } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import ReactHighcharts from 'react-highcharts';

const utils = require('../../components/utils');
const SOURCE = '';
const BORDER_COLOR = '#666666';

const AuctionOptimizerDevices = ({ devicesData, loading }) => {
    const formattedData = Object.entries(devicesData).map(x => [x[0], ((100*x[1].optimized)/(x[1].optimized + x[1].accepted))]).sort(([,a], [,b]) => b - a)
    const config = {
        chart: {
            type: 'bar',
            backgroundColor: 'none',
            borderColor: BORDER_COLOR,
            borderWidth: 1
        },
        title: {
            text: '% OPTIMIZED REQUESTS BY DEVICE',
            style: { color: '#ffffff', fontSize: '12px', fontWeight: 600 }
        },
        subtitle: { text: SOURCE },
        xAxis: {
            categories: loading ? [] : formattedData.map(x => x[0]),
            title: {
                text: null
            },
            lineWidth: 1,
            labels: {
                style: { color: '#ffffff', width: 40 },
            },
            crosshair: true,
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Optimized Requests (%)',
                align: 'high',
                style: { color: '#ffffff' }
            },
            labels: {
                overflow: 'justify',
                style: { color: '#ffffff', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontSize: '11px', fontWeight: 600 }
            },
            gridLineWidth: 0
        },
        tooltip: {
            valueSuffix: ' %'
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                    inside: true,
                    format: '{y}%',
                    style: { color: '#ffffff', fontSize: '12px', fontWeight: 600, textOutline: 'none' }
                },
                groupPadding: 0.1,
                colorByPoint: true,
                borderColor: false,
                colors: ["#a6a6a6", "#a0ce4e", "#00bea3", "#f1894c", "#ff497c", "#009fdb"],
            }
        },
        legend: false,
        credits: {
            enabled: false
        },
        series: [{
            name: 'Optimized',
            data: loading ? [] : formattedData.map(x => utils.roundDouble(x[1], 2))
        }]
    }
  
    return (
        <div style={{position: 'relative'}}>
            <Tooltip title={
                <React.Fragment>
                Optimized Requests are requests that the NoBid Auction Optimizer technology filters out from the auction.
                </React.Fragment>
            } style={{position: 'absolute', right: 0, margin: '10px', zIndex: 1}}>
                <HelpIcon/>
            </Tooltip>
            <ReactHighcharts config={config} />
        </div>
    )
}

export default AuctionOptimizerDevices;